/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Stats_ItemsInputs */

const id_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const ms_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const da_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const de_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const en_us2_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const es_es2_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const es_mx2_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítems`)
};

const fil_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Item`)
};

const fr_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const it_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articoli`)
};

const hu_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elemek`)
};

const nl_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const no_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elementer`)
};

const pl_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elementy`)
};

const pt_br2_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const pt_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itens`)
};

const ro_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elemente`)
};

const fi_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohteet`)
};

const sv_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objekt`)
};

const vi_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mục`)
};

const tr_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğeler`)
};

const cs_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Položky`)
};

const bg_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обекти`)
};

const ru_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объектов`)
};

const uk_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Елементів`)
};

const ar_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العناصر`)
};

const hi_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइटम`)
};

const th_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการ`)
};

const ja_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテム`)
};

const zh_cn2_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const zh_hant1_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const ko_components_stats_items = /** @type {(inputs: Components_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

/**
* | output |
* | --- |
* | "Items" |
*
* @param {Components_Stats_ItemsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_stats_items = /** @type {((inputs?: Components_Stats_ItemsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Stats_ItemsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_stats_items(inputs)
	if (locale === "ms") return ms_components_stats_items(inputs)
	if (locale === "da") return da_components_stats_items(inputs)
	if (locale === "de") return de_components_stats_items(inputs)
	if (locale === "en-US") return en_us2_components_stats_items(inputs)
	if (locale === "es-ES") return es_es2_components_stats_items(inputs)
	if (locale === "es-MX") return es_mx2_components_stats_items(inputs)
	if (locale === "fil") return fil_components_stats_items(inputs)
	if (locale === "fr") return fr_components_stats_items(inputs)
	if (locale === "it") return it_components_stats_items(inputs)
	if (locale === "hu") return hu_components_stats_items(inputs)
	if (locale === "nl") return nl_components_stats_items(inputs)
	if (locale === "no") return no_components_stats_items(inputs)
	if (locale === "pl") return pl_components_stats_items(inputs)
	if (locale === "pt-BR") return pt_br2_components_stats_items(inputs)
	if (locale === "pt") return pt_components_stats_items(inputs)
	if (locale === "ro") return ro_components_stats_items(inputs)
	if (locale === "fi") return fi_components_stats_items(inputs)
	if (locale === "sv") return sv_components_stats_items(inputs)
	if (locale === "vi") return vi_components_stats_items(inputs)
	if (locale === "tr") return tr_components_stats_items(inputs)
	if (locale === "cs") return cs_components_stats_items(inputs)
	if (locale === "bg") return bg_components_stats_items(inputs)
	if (locale === "ru") return ru_components_stats_items(inputs)
	if (locale === "uk") return uk_components_stats_items(inputs)
	if (locale === "ar") return ar_components_stats_items(inputs)
	if (locale === "hi") return hi_components_stats_items(inputs)
	if (locale === "th") return th_components_stats_items(inputs)
	if (locale === "ja") return ja_components_stats_items(inputs)
	if (locale === "zh-CN") return zh_cn2_components_stats_items(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_stats_items(inputs)
	return ko_components_stats_items(inputs)
});
export { components_stats_items as "components.stats.items" }